import { ThemeProvider } from "next-themes";

import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/components/providers/I18nProvider";
import { LocaleDirectionProvider } from "@/components/providers/LocaleDirectionProvider";
import { QueryProvider } from "@/components/providers/QueryProvider";
import { SessionProvider } from "@/lib/session-context";
import { DEFAULT_LANGUAGE, readClientLanguage } from "@/i18n/settings";

type AppProvidersProps = {
  children: React.ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  const initialLocale = readClientLanguage() ?? DEFAULT_LANGUAGE;

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <QueryProvider>
        <SessionProvider>
          <I18nProvider initialLocale={initialLocale}>
            <LocaleDirectionProvider>
              <TooltipProvider>
                {children}
                <Toaster richColors closeButton />
              </TooltipProvider>
            </LocaleDirectionProvider>
          </I18nProvider>
        </SessionProvider>
      </QueryProvider>
    </ThemeProvider>
  );
}
